import { Component, Input, Output } from '@angular/core';
import { ViewChild, EventEmitter } from '@angular/core';
import SwalComponent from './../../utils/custom-swal.component';
import { FormService } from './../../api/form.service';
import { DataObject } from '../../interfaces/data-objects';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'iv-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements ICellRendererAngularComp {
  @Input() identifier: any;
  @Input() value;
  @ViewChild('warnAlert', { static: true }) warnAlert: SwalComponent;
  @Input() showDelete = true;
  @Input() disabled = false;
  rowData: DataObject;
  swalOptions: DataObject;

  params: DataObject;
  componentParent: DataObject;

  @Output() deleteEvent = new EventEmitter();

  constructor(private formService: FormService) {
    this.swalOptions = this.getSwalOptions();
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.componentParent = params?.context?.componentParent;
    this.rowData = this.params?.data;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

  deleteClicked(event) {
    event.stopPropagation();
    this.warnAlert.fire();
    return false;
  }

  deleteItem(id) {
    id === undefined ? id = this.rowData || undefined : undefined;
  
    if (this.componentParent) {
      this.componentParent.onDeleteConfirmation(id);
      return;
    }

    this.deleteEvent.emit(id);
  }

  prevent(event) {
    event.preventDefault();
  }

  getSwalOptions() {
    const options = {
      showConfirmButton: true,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    };
    return this.formService.getSwalOptions(options);
  }

}

